function changeButtonStatus(button, status) {
  if (status === "default") {
    button.classList.add("bg-secondary-dark");
    button.classList.remove("bg-orange-500");
    button.classList.remove("bg-emerald-600");
    button.innerHTML = `<div class="flex gap-1 items-center"><svg class="icon"><use href="#icon-Send"/></svg>پیام شما</div>`;
  }

  if (status === "pending") {
    button.classList.add("bg-orange-500");
    button.classList.remove("bg-secondary-dark");
    button.classList.remove("bg-emerald-600");
    button.innerHTML = `<div class="flex gap-1 items-center"><svg class="icon animate-spin"><use href="#icon-loading-waiting"/></svg> در حال ارسال </div>`;
  }

  if (status === "completed") {
    button.classList.add("bg-emerald-600");
    button.classList.remove("bg-orange-500");
    button.classList.remove("bg-secondary-dark");
    button.innerHTML = `<div class="flex gap-1 items-center"><svg class="icon"><use href="#icon-Checkmark,-Done,-Check-3"/></svg> ارسال شد </div>`;
  }

  if (status === "error") {
    button.classList.add("bg-secondary-dark");
    button.classList.remove("bg-emerald-600");
    button.classList.remove("bg-orange-500");
    button.innerHTML = `<div class="flex gap-1 items-center"><svg class="icon"><use href="#icon-Delete,-Disabled-1"/></svg> خطایی رخ داد! </div>`;
  }
}

function contactForm() {
  const formContactUs = document.getElementById("formContactUs");
  const formContactUsSubmit = document.getElementById("formContactUsSubmit");

  if (!formContactUs || !formContactUsSubmit) return;

  formContactUs.addEventListener("submit", (e) => {
    e.preventDefault();
    changeButtonStatus(formContactUsSubmit, "pending");

    setTimeout(() => {
      const formData = new FormData(formContactUs);
      jQuery(($) => {
        $.ajax({
          type: "POST",
          url: restDetails.url + "cyn-api/v1/contact-form",
          data: formData,
          cache: false,
          processData: false,
          contentType: false,

          success: (res) => {
            formContactUs.reset();
            changeButtonStatus(formContactUsSubmit, "completed");

            setTimeout(() => {
              changeButtonStatus(formContactUsSubmit, "default");
            }, 1500);
          },

          error: (err) => {
            changeButtonStatus(formContactUsSubmit, "error");
          },
        });
      });
    }, 700);
  });
}

contactForm();

function customizeForm() {
  const formCustomize = document.getElementById("formCustomize");
  const formCustomizeSubmit = document.getElementById("formCustomizeSubmit");

  if (!formCustomize || !formCustomizeSubmit) return;

  formCustomize.addEventListener("submit", (e) => {
    e.preventDefault();
    changeButtonStatus(formCustomizeSubmit, "pending");

    setTimeout(() => {
      const formData = new FormData(formCustomize);
      jQuery(($) => {
        $.ajax({
          type: "POST",
          url: restDetails.url + "cyn-api/v1/customize_form",
          data: formData,
          cache: false,
          processData: false,
          contentType: false,

          success: (res) => {
            formCustomize.reset();
            changeButtonStatus(formCustomizeSubmit, "completed");

            setTimeout(() => {
              changeButtonStatus(formCustomizeSubmit, "default");
            }, 1500);
          },

          error: (err) => {
            changeButtonStatus(formCustomizeSubmit, "error");
          },
        });
      });
    }, 700);
  });
}

customizeForm();

// change attachement text in form customize

function inputText() {
  const inputFile = document.getElementById("file-upload");
  const labelFile = document.getElementById("label-upload");

  if (!inputFile || !labelFile) return;

  inputFile.addEventListener("change", () => {
    if (!inputFile.value) {
      labelFile.innerText = "لطفا تصویر خود را ضمیمه کنید";
    }
    labelFile.innerText = "تصویر ضمیمه شد";
  });
}

inputText();
